import { axios } from '../../../axios'

export const login = (credentials = {}) => {
  return axios.post('/auth/login', credentials).then(({ data }) => data)
}

export const register = (payload = {}) => {
  return axios.post('/auth/register', payload).then(({ data }) => data)
}
